'use client';

import { TextField, TextFieldProps } from '@mui/material';
import { FC, ReactNode } from 'react';

import { AbgTypography } from '@abg/kit-base';

import { LocationSuggestionOption } from '../../location-search.types';
import { LocationIcon } from '../location-icon/LocationIcon';

import {
  locationTextFieldLabelStyling,
  locationTextFieldStyling,
} from './LocationTextField.styling';

type LocationTextFieldProps = {
  location?: LocationSuggestionOption | null;
  defaultIcon?: FC;
  endAdornment?: ReactNode;
  testIdSuffix?: string;
  testIdPrefix?: string;
  hasIncorrectValue?: boolean;
  renderError?: () => ReactNode;
  placeholder?: string;
  label?: string;
  hideLocationIcon?: boolean;
} & TextFieldProps;

export const LocationTextField: FC<LocationTextFieldProps> = ({
  location,
  defaultIcon,
  endAdornment,
  testIdSuffix = 'input',
  testIdPrefix = '',
  hasIncorrectValue = false,
  renderError,
  placeholder,
  slotProps,
  label,
  hideLocationIcon = false,
  ...textFieldProps
}) => {
  return (
    <>
      {label && (
        <AbgTypography
          sx={locationTextFieldLabelStyling}
          data-testid="location-text-field-label"
        >
          {label}
        </AbgTypography>
      )}
      <TextField
        {...textFieldProps}
        sx={locationTextFieldStyling}
        slotProps={{
          ...slotProps,
          input: {
            ...slotProps?.input,
            endAdornment,
            startAdornment: hideLocationIcon ? undefined : (
              <LocationIcon
                location={location ?? null}
                {...(defaultIcon && { defaultIcon })}
                mode="input"
              />
            ),
          },
          htmlInput: {
            ...slotProps?.htmlInput,
            'data-testid': `${testIdPrefix}-${testIdSuffix}`,
          },
          inputLabel: {
            shrink: true,
            ...slotProps?.inputLabel,
          },
        }}
        variant="filled"
        fullWidth
        error={hasIncorrectValue}
        helperText={renderError?.()}
        {...(placeholder && { placeholder })}
      />
    </>
  );
};
